<div
  [ngClass]="size() === 'sm' ? 'py-2 text-sm' : 'py-2.5'"
  class="d-flex disabled:color-neutral-20 w-full appearance-none flex-row items-center overflow-hidden rounded-lg px-4 pl-3 outline-none ring-1 ring-neutral-40 placeholder:text-neutral-80 focus-within:border-0 focus-within:ring-2 focus-within:ring-primary focus-visible:outline-none disabled:border-neutral-20 disabled:bg-neutral-5 disabled:text-neutral-20">
  <div class="flex flex-grow items-center">
    <div class="flex-row">
      <div class="relative flex">
        <select
          (keydown)="selectKeyDown($event)"
          (ngModelChange)="onCountryCodeSelectChange($event)"
          [(ngModel)]="selectedCountry"
          class="bg-slate-50 dark:bg-slate-800 absolute col-start-1 row-start-1 w-full cursor-pointer appearance-none p-1 opacity-0"
          name="phoneNumberCountry">
          @for (country of countries; track country.code) {
            <option [ngValue]="country.code">{{ country.name }}</option>
          }
        </select>
        <div class="flex">
          <div class="left-1 top-2 mr-2 h-5 w-5 rounded-6xl object-fill outline outline-1 outline-neutral-40">
            <img
              [src]="imageSource"
              (error)="imageSource = 'assets/countries/country.svg'"
              class="h-full w-full object-fill"
              alt="{{ selectedCountry }}"
              payLibSkeletonLoader
              heightClass="min-h-full"
              widthClass="min-w-4" />
          </div>
          <svg
            aria-hidden="true"
            class="-ml-[6px] mt-[2px] h-[0.9rem] w-[0.9rem] fill-neutral-60/70"
            data-slot="icon"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg">
            <path
              clip-rule="evenodd"
              d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z"
              fill-rule="evenodd"></path>
          </svg>
        </div>
      </div>
    </div>

    <input
      (input)="onInputChange(value)"
      (keydown)="onKeyDown($event)"
      [(ngModel)]="value"
      [attr.aria-labelledby]="'label-' + name()"
      [disabled]="disabled()"
      [id]="name()"
      [name]="name()"
      [placeholder]="placeholder()"
      autocomplete="tel"
      class="flex-grow pl-[0.05rem] outline-none focus-visible:outline-none"
      type="tel" />
  </div>
</div>

<div class="my-2 sm:px-2">
  @if (
    helperText() &&
    (!ngControl.hasError('patternwithmessage') ||
      (!formSubmitted() && !ngControl.hasError('patternwithmessage')) ||
      (!formSubmitted() && ngControl.hasError('patternwithmessage')) ||
      !(formSubmitted() && ngControl.hasError('patternwithmessage')))
  ) {
    <span class="text-sm text-neutral-80" id="hint-phoneNumber">{{ helperText() }}</span>
  }

  <!-- Only display if the form has been submitted at least once -->
  @if (formSubmitted()) {
    <pay-field-multi-validator [ngControl]="[ngControl]" [pendingObs]="pendingSubject.asObservable()" />
  }
</div>
